// Polyfills -------------------------------------------------------------------

import 'core-js/es6/promise';
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'whatwg-fetch';
import '@webcomponents/custom-elements';

// Global Menus ----------------------------------------------------------------

import './styles/main.less';
import GlobalMenus from './scripts/global-menus';

// Automatic Initialization ----------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  GlobalMenus.initialize();
});

// -----------------------------------------------------------------------------

//
// Provide the GlobalMenus object as an export.
//
export { GlobalMenus };
export default GlobalMenus;



// WEBPACK FOOTER //
// ./src/index.js